var _mask, _ellipse, _path, _mask2, _ellipse2, _path2, _mask3, _ellipse3, _path3, _mask4, _ellipse4, _path4, _mask5, _ellipse5, _path5, _mask6, _ellipse6, _path6, _mask7, _ellipse7, _path7, _mask8, _ellipse8, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _mask9, _ellipse9, _path18, _mask0, _ellipse0, _path19, _mask1, _ellipse1, _path20, _mask10, _ellipse10, _path21, _mask11, _ellipse11, _path22, _mask12, _ellipse12, _path23, _mask13, _ellipse13, _path24, _mask14, _ellipse14, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRestricted = ({
  className,
  height = 79,
  titleId,
  title,
  ref,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161 79",
    fill: "none",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.039,
    cy: 4.38269,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.039,
    cy: 4.38269,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.003 4.38269C136.003 4.3831 136.003 4.38179 136.004 4.3793C136.004 4.3769 136.005 4.37441 136.006 4.37206C136.008 4.36758 136.01 4.36477 136.012 4.36293C136.014 4.3611 136.017 4.35834 136.023 4.35585C136.03 4.35288 136.037 4.35199 136.039 4.35199V7.62798C137.834 7.62798 139.279 6.16982 139.279 4.38269H136.003ZM136.039 4.35199C136.042 4.35199 136.049 4.35288 136.056 4.35585C136.062 4.35834 136.065 4.3611 136.067 4.36293C136.069 4.36477 136.071 4.36758 136.073 4.37206C136.074 4.37441 136.075 4.3769 136.075 4.3793C136.076 4.38179 136.075 4.3831 136.075 4.38269H132.8C132.8 6.16982 134.245 7.62798 136.039 7.62798V4.35199ZM136.075 4.38269C136.075 4.38228 136.076 4.38359 136.075 4.38608C136.075 4.38848 136.074 4.39097 136.073 4.39332C136.071 4.3978 136.069 4.40061 136.067 4.40245C136.065 4.40428 136.062 4.40703 136.056 4.40953C136.049 4.41249 136.042 4.41339 136.039 4.41339V1.1374C134.245 1.1374 132.8 2.59556 132.8 4.38269H136.075ZM136.039 4.41339C136.037 4.41339 136.03 4.41249 136.023 4.40953C136.017 4.40703 136.014 4.40428 136.012 4.40245C136.01 4.40061 136.008 4.3978 136.006 4.39332C136.005 4.39097 136.004 4.38848 136.004 4.38608C136.003 4.38359 136.003 4.38228 136.003 4.38269H139.279C139.279 2.59556 137.834 1.1374 136.039 1.1374V4.41339Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_6621_60607)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.553,
    cy: 26.6714,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.553,
    cy: 26.6714,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.862 26.6714C158.862 26.297 159.166 25.984 159.553 25.984V29.26C160.986 29.26 162.138 28.0958 162.138 26.6714H158.862ZM159.553 25.984C159.939 25.984 160.243 26.297 160.243 26.6714H156.967C156.967 28.0958 158.12 29.26 159.553 29.26V25.984ZM160.243 26.6714C160.243 27.0458 159.939 27.3587 159.553 27.3587V24.0827C158.12 24.0827 156.967 25.2469 156.967 26.6714H160.243ZM159.553 27.3587C159.166 27.3587 158.862 27.0458 158.862 26.6714H162.138C162.138 25.2469 160.986 24.0827 159.553 24.0827V27.3587Z",
    fill: "currentColor",
    mask: "url(#path-3-inside-2_6621_60607)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.44746,
    cy: 15.1186,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.44746,
    cy: 15.1186,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.756935 15.1186C0.756935 14.7442 1.06091 14.4313 1.44747 14.4313V17.7073C2.88056 17.7073 4.03293 16.5431 4.03293 15.1186H0.756935ZM1.44747 14.4313C1.83402 14.4313 2.138 14.7442 2.138 15.1186H-1.138C-1.138 16.5431 0.0143657 17.7073 1.44747 17.7073V14.4313ZM2.138 15.1186C2.138 15.493 1.83402 15.806 1.44747 15.806V12.53C0.0143657 12.53 -1.138 13.6942 -1.138 15.1186H2.138ZM1.44747 15.806C1.06091 15.806 0.756935 15.493 0.756935 15.1186H4.03293C4.03293 13.6942 2.88056 12.53 1.44747 12.53V15.806Z",
    fill: "currentColor",
    mask: "url(#path-5-inside-3_6621_60607)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.4006,
    cy: 51.5444,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.4006,
    cy: 51.5444,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7101 51.5444C21.7101 51.17 22.014 50.8571 22.4006 50.8571V54.1331C23.8337 54.1331 24.9861 52.9689 24.9861 51.5444H21.7101ZM22.4006 50.8571C22.7871 50.8571 23.0911 51.17 23.0911 51.5444H19.8151C19.8151 52.9689 20.9675 54.1331 22.4006 54.1331V50.8571ZM23.0911 51.5444C23.0911 51.9188 22.7871 52.2317 22.4006 52.2317V48.9558C20.9675 48.9558 19.8151 50.1199 19.8151 51.5444H23.0911ZM22.4006 52.2317C22.014 52.2317 21.7101 51.9188 21.7101 51.5444H24.9861C24.9861 50.1199 23.8337 48.9558 22.4006 48.9558V52.2317Z",
    fill: "currentColor",
    mask: "url(#path-7-inside-4_6621_60607)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.69,
    cy: 30.8901,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.69,
    cy: 30.8901,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.999 30.8901C130.999 30.5157 131.303 30.2028 131.69 30.2028V33.4788C133.123 33.4788 134.275 32.3146 134.275 30.8901H130.999ZM131.69 30.2028C132.076 30.2028 132.38 30.5157 132.38 30.8901H129.104C129.104 32.3146 130.257 33.4788 131.69 33.4788V30.2028ZM132.38 30.8901C132.38 31.2645 132.076 31.5774 131.69 31.5774V28.3015C130.257 28.3015 129.104 29.4656 129.104 30.8901H132.38ZM131.69 31.5774C131.303 31.5774 130.999 31.2645 130.999 30.8901H134.275C134.275 29.4656 133.123 28.3015 131.69 28.3015V31.5774Z",
    fill: "currentColor",
    mask: "url(#path-9-inside-5_6621_60607)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-6_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.522,
    cy: 74.5483,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.522,
    cy: 74.5483,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.831 74.5483C114.831 74.1739 115.135 73.861 115.522 73.861V77.137C116.955 77.137 118.107 75.9728 118.107 74.5483H114.831ZM115.522 73.861C115.908 73.861 116.212 74.1739 116.212 74.5483H112.936C112.936 75.9728 114.089 77.137 115.522 77.137V73.861ZM116.212 74.5483C116.212 74.9227 115.908 75.2357 115.522 75.2357V71.9597C114.089 71.9597 112.936 73.1238 112.936 74.5483H116.212ZM115.522 75.2357C115.135 75.2357 114.831 74.9227 114.831 74.5483H118.107C118.107 73.1238 116.955 71.9597 115.522 71.9597V75.2357Z",
    fill: "currentColor",
    mask: "url(#path-11-inside-6_6621_60607)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-7_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.6975,
    cy: 3.45066,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.6975,
    cy: 3.45066,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0069 3.45066C34.0069 3.07625 34.3109 2.76332 34.6975 2.76332V6.03931C36.1306 6.03931 37.2829 4.87513 37.2829 3.45066H34.0069ZM34.6975 2.76332C35.084 2.76332 35.388 3.07625 35.388 3.45066H32.112C32.112 4.87513 33.2644 6.03931 34.6975 6.03931V2.76332ZM35.388 3.45066C35.388 3.82507 35.084 4.138 34.6975 4.138V0.862005C33.2644 0.862005 32.112 2.02618 32.112 3.45066H35.388ZM34.6975 4.138C34.3109 4.138 34.0069 3.82507 34.0069 3.45066H37.2829C37.2829 2.02618 36.1306 0.862005 34.6975 0.862005V4.138Z",
    fill: "currentColor",
    mask: "url(#path-13-inside-7_6621_60607)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-8_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.76206,
    cy: 62.246,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.76206,
    cy: 62.246,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72597 62.246C2.72597 62.2464 2.72595 62.2451 2.72646 62.2426C2.72695 62.2402 2.72772 62.2377 2.72871 62.2353C2.7306 62.2309 2.73277 62.228 2.73459 62.2262C2.73642 62.2244 2.73981 62.2216 2.74569 62.2191C2.75267 62.2162 2.7593 62.2153 2.76206 62.2153V65.4913C4.55659 65.4913 6.00196 64.0331 6.00196 62.246H2.72597ZM2.76206 62.2153C2.76481 62.2153 2.77145 62.2162 2.77843 62.2191C2.78431 62.2216 2.7877 62.2244 2.78953 62.2262C2.79135 62.228 2.79352 62.2309 2.79541 62.2353C2.7964 62.2377 2.79717 62.2402 2.79766 62.2426C2.79817 62.2451 2.79815 62.2464 2.79815 62.246H-0.477839C-0.477839 64.0331 0.967524 65.4913 2.76206 65.4913V62.2153ZM2.79815 62.246C2.79815 62.2456 2.79817 62.2469 2.79766 62.2494C2.79717 62.2518 2.7964 62.2543 2.79541 62.2566C2.79352 62.2611 2.79135 62.2639 2.78953 62.2657C2.7877 62.2676 2.78431 62.2703 2.77843 62.2728C2.77145 62.2758 2.76481 62.2767 2.76206 62.2767V59.0007C0.967524 59.0007 -0.477839 60.4588 -0.477839 62.246H2.79815ZM2.76206 62.2767C2.7593 62.2767 2.75267 62.2758 2.74569 62.2728C2.73981 62.2703 2.73642 62.2676 2.73459 62.2657C2.73277 62.2639 2.7306 62.2611 2.72871 62.2566C2.72772 62.2543 2.72695 62.2518 2.72646 62.2494C2.72595 62.2469 2.72597 62.2456 2.72597 62.246H6.00196C6.00196 60.4588 4.55659 59.0007 2.76206 59.0007V62.2767Z",
    fill: "currentColor",
    mask: "url(#path-15-inside-8_6621_60607)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6127 25.9202C26.6127 27.601 25.2554 28.9589 23.5869 28.9589C21.9185 28.9589 20.5612 27.601 20.5612 25.9202C20.5612 24.2394 21.9185 22.8815 23.5869 22.8815C25.2554 22.8815 26.6127 24.2394 26.6127 25.9202Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.638
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M133.719 57.4733C133.719 58.4716 132.914 59.2761 131.925 59.2761C130.937 59.2761 130.131 58.4716 130.131 57.4733C130.131 56.4751 130.937 55.6706 131.925 55.6706C132.914 55.6706 133.719 56.4751 133.719 57.4733Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.638
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1005 16.9668H46.9766V24.0629",
    stroke: "currentColor",
    strokeWidth: 2.52583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.648 37.2422V42.3109",
    stroke: "currentColor",
    strokeWidth: 2.52583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.523 16.9668H112.647V24.0629",
    stroke: "currentColor",
    strokeWidth: 2.52583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1005 62.5845H46.9766V54.4746",
    stroke: "currentColor",
    strokeWidth: 2.52583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.523 62.5845H112.647V54.4746",
    stroke: "currentColor",
    strokeWidth: 2.52583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9766 35.0078V39.0627",
    stroke: "currentColor",
    strokeWidth: 2.52583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9766 43.1283L46.9866 43.1172",
    stroke: "currentColor",
    strokeWidth: 2.52583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8148 39.0631C55.8148 43.9683 51.8528 47.9375 46.9744 47.9375C42.096 47.9375 38.134 43.9683 38.134 39.0631C38.134 34.1579 42.096 30.1887 46.9744 30.1887C51.8528 30.1887 55.8148 34.1579 55.8148 39.0631Z",
    stroke: "currentColor",
    strokeWidth: 2.52583
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8636 35.5909V30.1364C72.8636 28.1111 73.6682 26.1687 75.1003 24.7366C76.5324 23.3045 78.4747 22.5 80.5 22.5C82.5253 22.5 84.4676 23.3045 85.8997 24.7366C87.3318 26.1687 88.1364 28.1111 88.1364 30.1364V35.5909M80.5 43.2273V47.5909M70.6818 35.5909H90.3182C90.3182 35.5909 92.5 35.5909 92.5 37.7727V53.0455C92.5 53.0455 92.5 55.2273 90.3182 55.2273H70.6818C70.6818 55.2273 68.5 55.2273 68.5 53.0455V37.7727C68.5 37.7727 68.5 35.5909 70.6818 35.5909Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export const Icon = ({
  className: propClassName = "",
  fill = "none",
  stroke = "currentColor",
  weight = "normal",
  height = 79,
  titleId,
  title,
  ref,
  ...props
}) => {
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161 79",
    fill: fill,
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.039,
    cy: 4.38269,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.039,
    cy: 4.38269,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M136.003 4.38269C136.003 4.3831 136.003 4.38179 136.004 4.3793C136.004 4.3769 136.005 4.37441 136.006 4.37206C136.008 4.36758 136.01 4.36477 136.012 4.36293C136.014 4.3611 136.017 4.35834 136.023 4.35585C136.03 4.35288 136.037 4.35199 136.039 4.35199V7.62798C137.834 7.62798 139.279 6.16982 139.279 4.38269H136.003ZM136.039 4.35199C136.042 4.35199 136.049 4.35288 136.056 4.35585C136.062 4.35834 136.065 4.3611 136.067 4.36293C136.069 4.36477 136.071 4.36758 136.073 4.37206C136.074 4.37441 136.075 4.3769 136.075 4.3793C136.076 4.38179 136.075 4.3831 136.075 4.38269H132.8C132.8 6.16982 134.245 7.62798 136.039 7.62798V4.35199ZM136.075 4.38269C136.075 4.38228 136.076 4.38359 136.075 4.38608C136.075 4.38848 136.074 4.39097 136.073 4.39332C136.071 4.3978 136.069 4.40061 136.067 4.40245C136.065 4.40428 136.062 4.40703 136.056 4.40953C136.049 4.41249 136.042 4.41339 136.039 4.41339V1.1374C134.245 1.1374 132.8 2.59556 132.8 4.38269H136.075ZM136.039 4.41339C136.037 4.41339 136.03 4.41249 136.023 4.40953C136.017 4.40703 136.014 4.40428 136.012 4.40245C136.01 4.40061 136.008 4.3978 136.006 4.39332C136.005 4.39097 136.004 4.38848 136.004 4.38608C136.003 4.38359 136.003 4.38228 136.003 4.38269H139.279C139.279 2.59556 137.834 1.1374 136.039 1.1374V4.41339Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_6621_60607)"
  })), _mask0 || (_mask0 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.553,
    cy: 26.6714,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.553,
    cy: 26.6714,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M158.862 26.6714C158.862 26.297 159.166 25.984 159.553 25.984V29.26C160.986 29.26 162.138 28.0958 162.138 26.6714H158.862ZM159.553 25.984C159.939 25.984 160.243 26.297 160.243 26.6714H156.967C156.967 28.0958 158.12 29.26 159.553 29.26V25.984ZM160.243 26.6714C160.243 27.0458 159.939 27.3587 159.553 27.3587V24.0827C158.12 24.0827 156.967 25.2469 156.967 26.6714H160.243ZM159.553 27.3587C159.166 27.3587 158.862 27.0458 158.862 26.6714H162.138C162.138 25.2469 160.986 24.0827 159.553 24.0827V27.3587Z",
    fill: "currentColor",
    mask: "url(#path-3-inside-2_6621_60607)"
  })), _mask1 || (_mask1 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.44746,
    cy: 15.1186,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.44746,
    cy: 15.1186,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0.756935 15.1186C0.756935 14.7442 1.06091 14.4313 1.44747 14.4313V17.7073C2.88056 17.7073 4.03293 16.5431 4.03293 15.1186H0.756935ZM1.44747 14.4313C1.83402 14.4313 2.138 14.7442 2.138 15.1186H-1.138C-1.138 16.5431 0.0143657 17.7073 1.44747 17.7073V14.4313ZM2.138 15.1186C2.138 15.493 1.83402 15.806 1.44747 15.806V12.53C0.0143657 12.53 -1.138 13.6942 -1.138 15.1186H2.138ZM1.44747 15.806C1.06091 15.806 0.756935 15.493 0.756935 15.1186H4.03293C4.03293 13.6942 2.88056 12.53 1.44747 12.53V15.806Z",
    fill: "currentColor",
    mask: "url(#path-5-inside-3_6621_60607)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.4006,
    cy: 51.5444,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.4006,
    cy: 51.5444,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7101 51.5444C21.7101 51.17 22.014 50.8571 22.4006 50.8571V54.1331C23.8337 54.1331 24.9861 52.9689 24.9861 51.5444H21.7101ZM22.4006 50.8571C22.7871 50.8571 23.0911 51.17 23.0911 51.5444H19.8151C19.8151 52.9689 20.9675 54.1331 22.4006 54.1331V50.8571ZM23.0911 51.5444C23.0911 51.9188 22.7871 52.2317 22.4006 52.2317V48.9558C20.9675 48.9558 19.8151 50.1199 19.8151 51.5444H23.0911ZM22.4006 52.2317C22.014 52.2317 21.7101 51.9188 21.7101 51.5444H24.9861C24.9861 50.1199 23.8337 48.9558 22.4006 48.9558V52.2317Z",
    fill: "currentColor",
    mask: "url(#path-7-inside-4_6621_60607)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.69,
    cy: 30.8901,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.69,
    cy: 30.8901,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M130.999 30.8901C130.999 30.5157 131.303 30.2028 131.69 30.2028V33.4788C133.123 33.4788 134.275 32.3146 134.275 30.8901H130.999ZM131.69 30.2028C132.076 30.2028 132.38 30.5157 132.38 30.8901H129.104C129.104 32.3146 130.257 33.4788 131.69 33.4788V30.2028ZM132.38 30.8901C132.38 31.2645 132.076 31.5774 131.69 31.5774V28.3015C130.257 28.3015 129.104 29.4656 129.104 30.8901H132.38ZM131.69 31.5774C131.303 31.5774 130.999 31.2645 130.999 30.8901H134.275C134.275 29.4656 133.123 28.3015 131.69 28.3015V31.5774Z",
    fill: "currentColor",
    mask: "url(#path-9-inside-5_6621_60607)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-6_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.522,
    cy: 74.5483,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.522,
    cy: 74.5483,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.831 74.5483C114.831 74.1739 115.135 73.861 115.522 73.861V77.137C116.955 77.137 118.107 75.9728 118.107 74.5483H114.831ZM115.522 73.861C115.908 73.861 116.212 74.1739 116.212 74.5483H112.936C112.936 75.9728 114.089 77.137 115.522 77.137V73.861ZM116.212 74.5483C116.212 74.9227 115.908 75.2357 115.522 75.2357V71.9597C114.089 71.9597 112.936 73.1238 112.936 74.5483H116.212ZM115.522 75.2357C115.135 75.2357 114.831 74.9227 114.831 74.5483H118.107C118.107 73.1238 116.955 71.9597 115.522 71.9597V75.2357Z",
    fill: "currentColor",
    mask: "url(#path-11-inside-6_6621_60607)"
  })), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-7_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.6975,
    cy: 3.45066,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.6975,
    cy: 3.45066,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0069 3.45066C34.0069 3.07625 34.3109 2.76332 34.6975 2.76332V6.03931C36.1306 6.03931 37.2829 4.87513 37.2829 3.45066H34.0069ZM34.6975 2.76332C35.084 2.76332 35.388 3.07625 35.388 3.45066H32.112C32.112 4.87513 33.2644 6.03931 34.6975 6.03931V2.76332ZM35.388 3.45066C35.388 3.82507 35.084 4.138 34.6975 4.138V0.862005C33.2644 0.862005 32.112 2.02618 32.112 3.45066H35.388ZM34.6975 4.138C34.3109 4.138 34.0069 3.82507 34.0069 3.45066H37.2829C37.2829 2.02618 36.1306 0.862005 34.6975 0.862005V4.138Z",
    fill: "currentColor",
    mask: "url(#path-13-inside-7_6621_60607)"
  })), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-8_6621_60607",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.76206,
    cy: 62.246,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.76206,
    cy: 62.246,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72597 62.246C2.72597 62.2464 2.72595 62.2451 2.72646 62.2426C2.72695 62.2402 2.72772 62.2377 2.72871 62.2353C2.7306 62.2309 2.73277 62.228 2.73459 62.2262C2.73642 62.2244 2.73981 62.2216 2.74569 62.2191C2.75267 62.2162 2.7593 62.2153 2.76206 62.2153V65.4913C4.55659 65.4913 6.00196 64.0331 6.00196 62.246H2.72597ZM2.76206 62.2153C2.76481 62.2153 2.77145 62.2162 2.77843 62.2191C2.78431 62.2216 2.7877 62.2244 2.78953 62.2262C2.79135 62.228 2.79352 62.2309 2.79541 62.2353C2.7964 62.2377 2.79717 62.2402 2.79766 62.2426C2.79817 62.2451 2.79815 62.2464 2.79815 62.246H-0.477839C-0.477839 64.0331 0.967524 65.4913 2.76206 65.4913V62.2153ZM2.79815 62.246C2.79815 62.2456 2.79817 62.2469 2.79766 62.2494C2.79717 62.2518 2.7964 62.2543 2.79541 62.2566C2.79352 62.2611 2.79135 62.2639 2.78953 62.2657C2.7877 62.2676 2.78431 62.2703 2.77843 62.2728C2.77145 62.2758 2.76481 62.2767 2.76206 62.2767V59.0007C0.967524 59.0007 -0.477839 60.4588 -0.477839 62.246H2.79815ZM2.76206 62.2767C2.7593 62.2767 2.75267 62.2758 2.74569 62.2728C2.73981 62.2703 2.73642 62.2676 2.73459 62.2657C2.73277 62.2639 2.7306 62.2611 2.72871 62.2566C2.72772 62.2543 2.72695 62.2518 2.72646 62.2494C2.72595 62.2469 2.72597 62.2456 2.72597 62.246H6.00196C6.00196 60.4588 4.55659 59.0007 2.76206 59.0007V62.2767Z",
    fill: "currentColor",
    mask: "url(#path-15-inside-8_6621_60607)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.6127 25.9202C26.6127 27.601 25.2554 28.9589 23.5869 28.9589C21.9185 28.9589 20.5612 27.601 20.5612 25.9202C20.5612 24.2394 21.9185 22.8815 23.5869 22.8815C25.2554 22.8815 26.6127 24.2394 26.6127 25.9202Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 1.638
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.719 57.4733C133.719 58.4716 132.914 59.2761 131.925 59.2761C130.937 59.2761 130.131 58.4716 130.131 57.4733C130.131 56.4751 130.937 55.6706 131.925 55.6706C132.914 55.6706 133.719 56.4751 133.719 57.4733Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 1.638
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1005 16.9668H46.9766V24.0629",
    stroke: stroke,
    strokeWidth: 2.52583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.648 37.2422V42.3109",
    stroke: stroke,
    strokeWidth: 2.52583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.523 16.9668H112.647V24.0629",
    stroke: stroke,
    strokeWidth: 2.52583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1005 62.5845H46.9766V54.4746",
    stroke: stroke,
    strokeWidth: 2.52583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.523 62.5845H112.647V54.4746",
    stroke: stroke,
    strokeWidth: 2.52583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9766 35.0078V39.0627",
    stroke: stroke,
    strokeWidth: 2.52583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9766 43.1283L46.9866 43.1172",
    stroke: stroke,
    strokeWidth: 2.52583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8148 39.0631C55.8148 43.9683 51.8528 47.9375 46.9744 47.9375C42.096 47.9375 38.134 43.9683 38.134 39.0631C38.134 34.1579 42.096 30.1887 46.9744 30.1887C51.8528 30.1887 55.8148 34.1579 55.8148 39.0631Z",
    stroke: stroke,
    strokeWidth: 2.52583
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8636 35.5909V30.1364C72.8636 28.1111 73.6682 26.1687 75.1003 24.7366C76.5324 23.3045 78.4747 22.5 80.5 22.5C82.5253 22.5 84.4676 23.3045 85.8997 24.7366C87.3318 26.1687 88.1364 28.1111 88.1364 30.1364V35.5909M80.5 43.2273V47.5909M70.6818 35.5909H90.3182C90.3182 35.5909 92.5 35.5909 92.5 37.7727V53.0455C92.5 53.0455 92.5 55.2273 90.3182 55.2273H70.6818C70.6818 55.2273 68.5 55.2273 68.5 53.0455V37.7727C68.5 37.7727 68.5 35.5909 70.6818 35.5909Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgRestricted;
export const raw = __webpack_public_path__ + "static/media/restricted.6f3595e1ede0048b7aaa7d4701838804.svg";